export default __webpack_public_path__ + "static/media/oggi4.8e687a74.jpg";